import { AppState, Auth0ProviderOptions } from "@auth0/auth0-react";
import { completeAuth0BrowserHandoff } from "./lib/auth/authRedirectNavigate";
import { Domain, getDomain } from "./utils/domain";

const AUTH0_DOMAIN: string | undefined = import.meta.env.VITE_AUTH0_DOMAIN;
const LARA_AUTH0_CLIENT_ID: string | undefined = import.meta.env
  .VITE_LARA_AUTH0_CLIENT_ID;
const LODA_AUTH0_CLIENT_ID: string | undefined = import.meta.env
  .VITE_LODA_AUTH0_CLIENT_ID;
const AUTH0_AUDIENCE: string | undefined = import.meta.env.VITE_AUTH0_AUDIENCE;

if (
  !AUTH0_DOMAIN ||
  !LARA_AUTH0_CLIENT_ID ||
  !LODA_AUTH0_CLIENT_ID ||
  !AUTH0_AUDIENCE
) {
  throw new Error("Missing Auth env variables");
}

const onRedirectCallback = (appState: AppState | undefined) => {
  const urlFallback =
    window.location.pathname +
    window.location.search +
    window.location.hash;
  completeAuth0BrowserHandoff(appState?.returnTo, urlFallback);
};

const clientId =
  getDomain(window.location.host) === Domain.LODA
    ? LODA_AUTH0_CLIENT_ID
    : LARA_AUTH0_CLIENT_ID;

if (!clientId) {
  throw new Error("Missing Auth0 Client ID for selected domain");
}

const Auth0ProviderConfig: Auth0ProviderOptions = {
  domain: AUTH0_DOMAIN,
  clientId: clientId,
  useRefreshTokens: true,
  useRefreshTokensFallback: true,
  cacheLocation: "localstorage",
  onRedirectCallback,
  authorizationParams: {
    redirect_uri: window.location.origin,
    scope: "openid profile email offline_access",
    ...(AUTH0_AUDIENCE
      ? {
          audience: AUTH0_AUDIENCE,
        }
      : null),
  },
};

export default Auth0ProviderConfig;
